import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    LazyAction,
} from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "BookwithmeAttendee" */ './lazyIndex'),
    { name: 'BookwithmeAttendee' }
);

// Lazy Components
export const BookingPageContainer = createLazyComponent(lazyModule, m => m.BookingPageContainer);

// Lazy Actions
export const lazySetAttendeeEntryPoint = new LazyAction(lazyModule, m => m.setEntryPoint);
export const lazySetBookingData = new LazyAction(lazyModule, m => m.setBookingData);
export const lazySetBookingMailbox = new LazyAction(lazyModule, m => m.setBookingMailbox);
export const lazySetBookingPageErrorState = new LazyAction(
    lazyModule,
    m => m.setBookingPageErrorState
);
export const lazySetBookingSignedUrl = new LazyAction(lazyModule, m => m.setBookingSignedUrl);
export const lazySetSignedUrlBookabilityData = new LazyAction(
    lazyModule,
    m => m.setSignedUrlBookabilityData
);
export const lazySetDisplayTimeZone = new LazyAction(lazyModule, m => m.setDisplayTimeZone);
export const lazySetInitialRequestState = new LazyAction(lazyModule, m => m.setInitialRequestState);
export const lazySetEditBooking = new LazyAction(lazyModule, m => m.setEditBooking);
export const lazyInitiateCookieRefresh = new LazyAction(lazyModule, m => m.initiateCookieRefresh);
export const lazySetAttendeeCurrentMeetingTypeID = new LazyAction(
    lazyModule,
    m => m.setCurrentMeetingTypeID
);

// Schema
export type { PersonalBookingData } from './store/schema/PersonalBookingData';
export type { CheckBookableResponse } from './services/schema/CheckBookableResponse';

// Services
export { checkBookableAndUpdateTotalBookings } from './services/checkBookableAndUpdateTotalBookings';
export { getBookingSessionData } from './services/getBookingSessionData';

// Utils
export const lazyTrySetBookingUser = new LazyAction(lazyModule, m => m.trySetBookingUser);
export { initBookWithMeFreeBusyCache } from './utils/initBookWithMeFreeBusyCache';

// Selectors
export { default as getCurrentMeetingTypeId } from './selectors/getCurrentMeetingTypeId';
export { default as getBookingMeetingTypeId } from './selectors/getBookingMeetingTypeId';
export { default as getUrlBookingId } from './selectors/getUrlBookingId';
export { default as getBookingMailbox } from './selectors/getBookingMailbox';

// Lazy Orchestrators
import { openBookingPage, openMeetingTypePage, openMeetingDetailsPage } from 'bookwithme-routes';
registerLazyOrchestrator(openBookingPage, lazyModule, m => m.openBookingPageOrchestrator);
registerLazyOrchestrator(openMeetingTypePage, lazyModule, m => m.openMeetingTypePageOrchestrator);
registerLazyOrchestrator(
    openMeetingDetailsPage,
    lazyModule,
    m => m.openMeetingDetailsPageOrchestrator
);
